import React, {Fragment} from 'react';

import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {FolderItem} from 'app/folders/components/FolderItem';
import {MenuItemsType} from 'app/general/widgets/ThreeDotsDropdownMenu';
import {gt} from 'app/utils/i18n';

import {
  FolderSerializedType,
  KBCategorySerializedType,
  KnowledgebaseSerializedType,
} from 'sweet-types';

type KBItemType = KBCategorySerializedType | KnowledgebaseSerializedType;

interface Props {
  kbList: KBItemType[] | undefined;
  itemName: string;
  refreshPosition: () => void;
  getItemCaption?: (KBItemType) => string | undefined;
  setParentFolder: (parentFolder: KBItemType) => void;
  defaultKBIcon?: string;
  actionsGetter?: (
    object: any,
    afterAction?: () => Promise<any>
  ) => MenuItemsType;
}

export const KBItemList = ({
  kbList,
  itemName,
  refreshPosition,
  getItemCaption,
  setParentFolder,
  defaultKBIcon,
  actionsGetter,
}: Props) => {
  return kbList == null ? (
    <p className="text-center py-3 px-3 mb-0">
      <i className="fa fa-circle-notch fa-spin mr-2" />
      {gt(`Loading ${itemName}`)}...
    </p>
  ) : (
    <div className="overflow-auto">
      {kbList.length > 0 ? (
        <Fragment>
          {kbList.map((item) => (
            <FolderItem
              small={true}
              folder={item}
              key={item.url}
              isParentDirty={false}
              isHidingDocuments={true}
              isHidingCreateDocument={true}
              isHidingCreateFolder={false}
              isCreateFolderPopup={true}
              isMillerColumn={true}
              isHidingTeams={true}
              itemCaption={
                getItemCaption != null ? getItemCaption(item) : undefined
              }
              setParentFolder={setParentFolder}
              defaultFolderIcon={defaultKBIcon}
              actionsGetter={actionsGetter}
              onToggle={(
                isExpanded: boolean,
                item: FolderSerializedType,
                promise: Promise<any>
              ) => {
                promise.then(refreshPosition);
              }}
            />
          ))}
        </Fragment>
      ) : (
        <NoResultsMessage
          onSidebar={false}
          onPopover={true}
          icon="fa-folder"
          head={gt(`No ${itemName} found`)}
          classNameOverwrite="my-4 text-center"
        />
      )}
    </div>
  );
};
